import * as React from "react";
import glamorous from "glamorous";

//Used to position us in the centre
const OuterContainer = glamorous("div")({
	position: "relative",
	top: "calc(-50% - 75px)",
	zIndex: 4,
	width: "100%",
	height: 0
});

const ContentContainer = glamorous("div")({
	borderRadius: "50%",
	backgroundColor: "#7F7F7F",
	width: 150,
	height: 150,
	textAlign: "center",
	margin: "0 auto",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	padding: "0.5em"
});

const Person = () => <img width="91" height="92" src={require("./You.png")} />;

const Text = glamorous("p")({
	color: "#FEFEFE",
	fontWeight: "bold",
	// marginTop: "0.5em"
	fontSize: "0.9em"
});

const CenterQuadNavigation = () => (
	<OuterContainer>
		<ContentContainer>
			<Person />
			<Text>Owner/Manager</Text>
		</ContentContainer>
	</OuterContainer>
);

export default CenterQuadNavigation;



// WEBPACK FOOTER //
// ./src/components/CenterQuadNavigation.tsx